<template>
  <client-only>
    <checkout-apple-pay-button v-if="isApplePayEnabled" class="w-full" @click="handleApplePay" />
  </client-only>
</template>

<script lang="ts" setup>
const {
  allowApplePayOrderOnPDP,
  allowApplePayOrderOnPDPWithBopis
} = useExpressPaymentFeatures()
const {
  handleNextAttribute,
  isSignInToBuy,
  shippingMethod,
  triggerApplePaySession
} = usePdp()

const { DialogSignIn } = useDialogsStore()
const auth = useAuthStore()
const cart = useCartStore()

const { pending: isCartPending } = storeToRefs(cart)

const isApplePayEnabled = computed(() =>
  allowApplePayOrderOnPDP.value
  && window.ApplePaySession
  && (allowApplePayOrderOnPDPWithBopis.value || shippingMethod.value !== 'pickup')
)

const handleSignInToBuy = async () => {
  if (isSignInToBuy.value) {
    await DialogSignIn.open({
      formLocation: 'modal:single:pdp:none',
      isSignInToBuy: true
    })
    if (auth.loggedIn) {
      await until(isCartPending).toBe(false)
      return handleSignInToBuy()
    }
    throw new Error('User not signed in')
  }
}

const handleApplePay = async () => {
  try {
    await handleSignInToBuy()
    handleNextAttribute({ enableApplePay: true }, () => triggerApplePaySession())
  }
  catch (e) {
    console.info(e)
  }
}
</script>
